import { FC, useEffect, useState } from "react";
import { api } from "../../api/axiosClient";
import "../../assets/css/HomePage/homePage.css";
import "../../assets/css/landing-page.css";
import SearchTrainer from "./components/SearchTrainer";
import Steps from "./components/Steps";
import MainPageBanner from "../../components/MainPageBanner";
import RegisterForm from "../Auth/components/RegisterForm";

interface Portal {
  id: number;
  name: string;
  banner_image: string;
  banner_link: string;
  is_active: boolean;
  order: number;
}

interface MainPageConfig {
  show_main_page_banner: boolean;
  main_page_banner: Portal | null;
}

const HomePage: FC<{}> = () => {
  const [mainPageConfig, setMainPageConfig] = useState<MainPageConfig | null>(
    null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMainPageConfig = async () => {
      try {
        const response = await api.get("/main-page-config/");
        setMainPageConfig(response.data);
      } catch (error) {
        console.error("Error fetching main page config:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMainPageConfig();
  }, []);

  if (loading) {
    return null; // or add a loading spinner if needed
  }

  return (
    <>
      <header>
        <SearchTrainer />
      </header>
      <section className="no-height-section">
        <Steps />
      </section>
      {mainPageConfig?.show_main_page_banner &&
        mainPageConfig.main_page_banner && (
          <MainPageBanner banner={mainPageConfig.main_page_banner} />
        )}
      <section className="dark-bg">
        <RegisterForm title="Zarejestruj się za darmo!" />
      </section>
    </>
  );
};

export default HomePage;
